import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";

@Component({
    selector: "list-cell",
    template: `
        <ul>
          @for (i of list; track i) {
            <li class="bullet" [innerHtml]="i | safeHtml"></li>
          }
        </ul>
        `,
    styles: [
        `
        .bullet {
            line-height: 25px;
        }
        `
    ],
    standalone: false
})
export class ListComponent implements ICellRendererAngularComp {
    private params: any;

    list: Array<string> = [];

    constructor(){}

    async agInit(params: any): Promise<void> {
        if(params.value == null){
            return;
        }
        this.params = params;

        this.list = this.params.value;

    }

    refresh(params: any): boolean {
        this.params = params;
        
        this.list = this.params.value;

        return false;
    }
}